import { render, staticRenderFns } from "./DataCalendario.vue?vue&type=template&id=3a24db4c&"
import script from "./DataCalendario.vue?vue&type=script&lang=js&"
export * from "./DataCalendario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports